const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		// showHead: true,
		// showIDs: true,
		// showTDVerticalTop: true,
		// isSortable: true,
		// inline: false,
		// lazyloadStepSize: 10,
		// preventSortOfField: {},
		// sortByDragging: true,
		// headRowActions: {
		// 	toggleSortByDragging: {
		// 		show: true,
		// 		turnedOn: false,
		// 	},
		// },
		// rowActionsInline: true,
		// rowActionsProperties: {
		// 	colWidth: '65px',
		// },
		// rowActions: {
		// 	edit: true,
		// 	customs: [
		// 		{
		// 			buttonType: 'delete',
		// 			neutral: true,
		// 		}
		// 	]
		// },
		// heartbeatRefreshOn: {
		// 	'reconnect': true,
		// 	'resourceChanged.bosch_tripCostCenters': true,
		// },
	},

	// model: {
	// 	// resourceFilters: {
	// 	// 	order: [{
	// 	// 		fieldCode: 'position',
	// 	// 		direction: 'asc'
	// 	// 	}]
	// 	// }
	// },

	methods: {

		// async onConfigSanitized(originalConfig, lastConfig){
		// 	const storage = this.getStorage()
		// 	if(storage.isServer) return;
		// 	if(!this.config.headRowActions.toggleSortByDragging.show) return;
		//
		// 	if(this.config.headRowActions.toggleSortByDragging.prevTurnedOn === undefined) {
		// 		this.config.headRowActions.toggleSortByDragging.prevTurnedOn = this.config.headRowActions.toggleSortByDragging.turnedOn
		// 	} else if (this.config.headRowActions.toggleSortByDragging.prevTurnedOn !== this.config.headRowActions.toggleSortByDragging.turnedOn){
		// 		this.config.headRowActions.toggleSortByDragging.prevTurnedOn = this.config.headRowActions.toggleSortByDragging.turnedOn
		//
		// 		// tweak params for sort mode toggle
		// 		if(this.config.headRowActions.toggleSortByDragging.turnedOn){
		// 			// save and set filters
		// 			this.config.showSortableIndicators = true
		// 			this.model.lastResourceFilters = utils.simpleCopy(this.model.resourceFilters || {})
		// 			this.model.resourceFilters.order = [{
		// 				fieldCode: 'position',
		// 				direction: 'asc'
		// 			}]
		// 			this.model.resourceFilters.offset = 0
		// 			this.model.resourceFilters.limit = 100
		// 		} else {
		// 			// restore filters
		// 			this.model.resourceFilters = utils.simpleCopy(this.model.lastResourceFilters || {})
		// 		}
		//
		// 		// toggle formColCapture
		// 		await this.toggleCaptureFormCol()
		// 	}
		// },

		async toggleCaptureFormCol(){
			const lastCaptureFormCol = this.model.lastCaptureFormCol = this.model.lastCaptureFormCol || {}

			const myColChildParent = this.$.closest('.col > *')[0]
			const otherColChildren = []
			let otherColChildrenMaxHeight = 0
			this.$.closest('.col').find('> *').each(function(a, b){
				if(myColChildParent !== this){
					otherColChildrenMaxHeight = Math.max(otherColChildrenMaxHeight, $(this).outerHeight(true) || 0)
					otherColChildren.push(this)
				}
			})

			if(otherColChildren.length < 1) return;

			const animation = {
				duration: .3,
				start: {},
				core: {
					ease: (Cubic || {}).easeInOut,
				},
				end: {},
				myParent: {},
			}

			if(this.config.headRowActions.toggleSortByDragging.turnedOn) {
				animation.start.height = otherColChildrenMaxHeight
				animation.start.padding = 16
				animation.start.opacity = 1
				animation.start.overflow = 'clip'

				animation.core.height = 0
				animation.core.padding = 0
				animation.core.opacity = 0

				animation.end.padding = 0

				animation.myParent['border-color'] = 'transparent'
			} else {

				animation.start.height = 0
				animation.start.padding = 0
				animation.start.opacity = 0
				animation.start.overflow = 'clip'

				if(lastCaptureFormCol.otherColChildrenMaxHeight){
					animation.core.height = lastCaptureFormCol.otherColChildrenMaxHeight
				}
				animation.core.padding = 16
				animation.core.opacity = 1

				animation.end.height = 'auto'
				animation.end.padding = 'revert-layer'
				animation.end.opacity = 1
				animation.end.overflow = 'visible'

				animation.myParent['border-color'] = 'revert-layer'
			}

			// show/hide other col-children
			const $otherColChildren = $(otherColChildren)
			const done = utils.promise.newCustom(this)

			try {
				if(animation.start){
					TweenMax.set(
						$otherColChildren,
						animation.start,
					)
				}
				if(animation.myParent){
					TweenMax.set(
						$(myColChildParent),
						animation.myParent,
					)
				}
				TweenMax.to(
					$otherColChildren,
					animation.duration,
					{
						...animation.core,
						onOverwrite(){
							done.resolve()
						},
						onComplete(){
							done.resolve()
						},
					},
				)
			} catch (error) {
				console.error(error)
				done.resolve()
			}

			await done

			if(animation.end){
				TweenMax.set(
					$otherColChildren,
					animation.end,
				)
			}

			lastCaptureFormCol.otherColChildrenMaxHeight = otherColChildrenMaxHeight
		},
	},
}